import { useEffect, useId, useRef } from 'react';
import { useBack } from '../store/back';

/** Register a back action for the native Telegram BackButton while `active`.
 *  The topmost active handler runs on back-press (closing an overlay or stepping
 *  back) before the route stack is popped. The latest `fn` closure is always used,
 *  so callers don't need to memoize it. */
export function useBackHandler(active: boolean, fn: () => void) {
  const id = useId();
  const fnRef = useRef(fn);
  fnRef.current = fn;

  const register = useBack((s) => s.register);
  const unregister = useBack((s) => s.unregister);

  useEffect(() => {
    if (!active) return;
    register(id, () => fnRef.current());
    return () => unregister(id);
  }, [active, id, register, unregister]);
}
